// Show the first tab by default
$('.tabs-stage .technical-tabs-content').hide();
$('.tabs-stage div:first').show();
$('.tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.tabs-nav .tabs-item').on('click', function(event) {
    event.preventDefault();
    $('.tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.tabs-stage .technical-tabs-content').hide();
    $('.technical-tabs-content').eq($(this).parent().index()).css({"display": "block"});
});

// Toggle description height and button text
$('#tab-1 .show-more').click(function() {
    var $content = $('#tab-1 .description-content');
    var isExpanded = $content.css('max-height') !== '436px';
    if (isExpanded) {
        $content.css('max-height', '436px');
        $(this).text('Прочети още');
    } else {
        $content.css('max-height', $content[0].scrollHeight + 'px');
        $(this).text('Покажи по-малко');
    }
});
